if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }

      this.submitButton = this.querySelector('[type="submit"]');
      this.updateCart();

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    connectedCallback() {
      this.cartBreakpoint = window.matchMedia('(min-width: 1100px)');
      this.onCartBreakpoint = () => this.updateCart();
      this.cartBreakpoint.addEventListener('change', this.onCartBreakpoint);
      this.updateCart();
    }

    disconnectedCallback() {
      this.cartBreakpoint?.removeEventListener('change', this.onCartBreakpoint);
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.updateCart();

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.updateCart();
          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.renderCart(response).catch(console.error) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            return this.renderCart(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.localName !== 'visual-cart-drawer' && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    resolveCart() {
      const visualCart = document.querySelector('visual-cart-drawer');
      return (typeof visualCart?.getSectionsToRender === 'function'
        && typeof visualCart.isEnabled === 'function' && visualCart.isEnabled() ? visualCart : null)
        || document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }

    updateCart() {
      this.cart = this.resolveCart();
      if (this.cart?.matches('visual-cart-drawer, cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      else this.submitButton.removeAttribute('aria-haspopup');
    }

    async renderCart(response) {
      this.updateCart();
      const cart = this.cart;
      if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }

      // A resize during the add request can change which cart sections are needed.
      if (cart.localName !== 'visual-cart-drawer') {
        const sectionIds = cart.getSectionsToRender().map((section) => section.id);
        if (sectionIds.some((id) => typeof response.sections?.[id] !== 'string')) {
          const url = new URL(window.location.href);
          url.searchParams.delete('section_id');
          url.searchParams.set('sections', sectionIds.join(','));
          try {
            const result = await fetch(url.toString(), { credentials: 'same-origin' });
            if (!result.ok) throw new Error('Cart sections could not be loaded.');
            const sections = await result.json();
            if (sectionIds.some((id) => typeof sections?.[id] !== 'string')) throw new Error('Cart sections are unavailable.');
            response = { ...response, sections: { ...response.sections, ...sections } };
          } catch {
            window.location = window.routes.cart_url;
            return;
          }
          this.updateCart();
          if (!this.cart || (this.cart !== cart && this.cart.localName !== 'visual-cart-drawer')) {
            window.location = window.routes.cart_url;
            return;
          }
        }
      }
      this.cart.renderContents(response);
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
